var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "mt-3 pt-1", attrs: { cols: "6", sm: "3" } },
            [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.label ? _vm.label + ": " : "") +
                    _vm._s(_vm.value.length) +
                    " Nodes"
                ),
              ]),
            ]
          ),
          _c(
            "v-col",
            { staticClass: "mt-2", attrs: { cols: "6", sm: "3" } },
            [
              !_vm.nodesExist
                ? _c("InputCSV", {
                    attrs: {
                      rowHandler: _vm.loadPrice,
                      onComplete: _vm.saveNodes,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function (ref) {
                            var triggerUpload = ref.triggerUpload
                            return [
                              _c("v-btn", { on: { click: triggerUpload } }, [
                                _vm._v("Upload Prices"),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4001375836
                    ),
                  })
                : _c(
                    "v-btn",
                    {
                      attrs: { color: "error" },
                      on: {
                        click: _vm.clearNodes,
                        change: function ($event) {
                          return _vm.$emit("change")
                        },
                      },
                    },
                    [_vm._v("Clear Nodes")]
                  ),
            ],
            1
          ),
          _vm.nodesExist
            ? _vm._l(_vm.reserves, function (reserve) {
                return _c(
                  "v-col",
                  { key: reserve.id, staticClass: "mt-2 shrink" },
                  [
                    _c("InputCSV", {
                      attrs: {
                        rowHandler: _vm.loadReserve(reserve.id),
                        onComplete: _vm.saveNodes,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$emit("change")
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var triggerUpload = ref.triggerUpload
                              return [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      disabled: _vm.loadedReserves.includes(
                                        reserve.id
                                      ),
                                    },
                                    on: { click: triggerUpload },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(reserve.name) + " Reserve Prices"
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                )
              })
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }